module.exports = __webpack_public_path__ + "img/huawei-wh.96fc4ea8.svg";